
import React, { useState, useRef, useEffect} from "react";


const svgThumbCache = {};
const svgFileCache = {};
const svgIndexCache = {};
const thumbUrlCache = {};

export default function SvgGlyphDialog({
    indexUrl,
    svgBaseUrl,
    defaultString = "",
    isOpen,
    onClose,
    onSave,
}) {

    const [glyphs, setGlyphs] = useState([]);
    // const [open, setOpen] = useState(false);

    const svgCache = useRef({});

    const loadIndex = async () => {

        if (svgIndexCache[indexUrl]) {
            setGlyphs(svgIndexCache[indexUrl]);
            return;
        }
    
    
        try {
    
            const response = await fetch(indexUrl);
            const data = await response.json();
    
            svgIndexCache[indexUrl] = data;
    
            setGlyphs(data);
    
        }
        catch(err) {
            console.error("SVG index loading error:", err);
        }
    };


    const loadSvg = async (glyph) => {

        if(svgFileCache[glyph.file])
            return svgFileCache[glyph.file];
    
    
        const response =
            await fetch(svgBaseUrl + glyph.file);
    
    
        const svgText =
            await response.text();
    
    
        const parser = new DOMParser();
    
        const doc =
            parser.parseFromString(
                svgText,
                "image/svg+xml"
            );
    
    
        const paths =
            [...doc.querySelectorAll("path")];
    
    
        const result = {
            svgPath:
                paths
                .map(p => p.getAttribute("d"))
                .join(" "),
    
            viewBox:
                doc.querySelector("svg")
                ?.getAttribute("viewBox")
                ||
                "0 0 100 100"
        };
    
    
        svgFileCache[glyph.file] = result;
    
        return result;
    };
    

 
    const selectGlyph = async (glyph) => {

        const svg =
            await loadSvg(glyph);


        glyph.svgPath =
            svg.svgPath;


        glyph.viewBox =
            svg.viewBox;

        // setOpen(false);
        onClose();

        if (onSave) {

            onSave(
                defaultString + glyph.file
            );

        }

    };

    const getThumbUrl = (file) => {

        if(!thumbUrlCache[file])
        {
            thumbUrlCache[file] =
                svgBaseUrl +
                "/color/thumbs/" +
                file.replace(".svg",".webp");
        }
    
        return thumbUrlCache[file];
    };


    useEffect(() => {

        if(isOpen)
        {
            loadIndex();            
        }

    }, [isOpen])

    return (
        <>
            {
                <div   style={{
                    ...styles.overlay,
                    display: isOpen ? "flex" : "none"
                }}>
                    <div
                        id="scroll-list" 
                        style={styles.dialog}>
                        <div style={styles.header}>
                            <h3>
                                SVG Glyphs ({glyphs.length})
                            </h3>

                            <button
                                style={styles.closeButton}
                                onClick={() => {onClose()}}
                            >
                                ✕
                            </button>
                        </div>

                        <div style={styles.grid}>
                            {
                                glyphs.map((g, i) => (

                                    <div
                                        key={i}
                                        style={styles.cell}
                                        onClick={() => selectGlyph(g)}
                                    >
                                        <img
                                            loading="lazy"
                                            src={getThumbUrl(g.file)}                                            
                                            style={{
                                                width: "60px",
                                                height: "60px",
                                                objectFit: "contain"
                                            }}
                                        />
                                        {/*
                                        <div
                                            style={{
                                                fontSize: "40px"
                                            }}
                                        >
                                            {g.char}
                                        </div>
                                        */}
                                        <div>
                                            {g.unicode}
                                        </div>

                                        <div style={styles.small}>
                                            {g.file}
                                        </div>


                                    </div>

                                ))
                            }
                        </div>
                    </div>
                </div>
            }
        </>
    );

}



const styles = {


    overlay: {

        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999

    },


    dialog: {

        background: "white",
        width: "80%",
        height: "80%",
        borderRadius: "8px",
        padding: "20px",
        overflow: "hidden",
        overscrollBehaviorY: "contain"

    },


    header: {

        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "40px"

    },


    closeButton: {

        border: "none",
        background: "transparent",
        fontSize: "24px",
        cursor: "pointer",
        padding: "5px 10px"

    },


    grid: {

        height: "calc(100% - 50px)",
        overflowY: "auto",
        display: "grid",
        gridTemplateColumns:
            "repeat(auto-fill, minmax(120px, 1fr))",
        gap: "10px"

    },


    cell: {

        border: "1px solid #ccc",
        padding: "10px",
        textAlign: "center",
        cursor: "pointer"

    },


    small: {
        fontSize: "12px",
        marginTop: "5px"

    }
};
